import { Transaction } from 'dexie';
import { DataMap, IDBVersionMigrator } from './interface';

const module: IDBVersionMigrator = {
    version: 1,
    description: 'Initial version',
    mappings: {
        IBackgroundModeDto: '++id,name',
        IBeaconDto: '++id,name,uuid,major,minor,siteId',
        IBeaconSensitivityDto: '++id,name',
        IFloorPlanDto:
            '++id,name,imageFileName,removeImage,imageMediumId,siteId,siteObjectsOnFloorPlanCount,styleId',
        IFontAlignmentDto: '++id,name',
        IFontFamilyDto: '++id,name',
        IFontSizeUnitDto: '++id,name',
        IFontStyleDto: '++id,name',
        ILanguageDto: '++id,name,code,isDefault',
        IMediumDto: '++id,mediumHash,fileName,mimeType,mediumSize,deleted,siteId',
        IMenuItemDto:
            '++id,name,namePropagation,imageFileName,removeImage,imageMediumId,siteId,toursCount,publishedToursCount,deleted',
        IMenuItemTranslationDto: '++id,menuItemId,languageId,name,deleted',
        IPinTypeDto: '++value,content,icon,text',
        IScreenOrientationDto: '++id,name',
        ISiteDto:
            '++id,name,logoFileName,removeLogo,logoMediumId,alarmEnabled,alarmPin,adminPin,languageSelectionMenu,tourSelectionMenu,clientId,screenOrientationId,majorVersion,minorVersion,toursCount,deviceAccountsCount,languageSelectionStyleId,tourSelectionStyleId',
        ISiteObjectOnFloorPlanDto:
            '++id,siteObjectId,floorPlanId,x,y,pinTypeId,pinColor,siteObjectName',
        ISiteObjectDto:
            '++id,name,int1,int2,int3,int4,altBoolean1,altBoolean2,isUniversal,keypadNumber,siteId,siteObjectTypeId,beaconId,beaconSensitivityId,fontSize,fontFamily,fontColor,menuPosition,nextObjectId,relatedObject1Id,relatedObject2Id,relatedObject3Id,relatedObject4Id,relatedObject5Id,removeForegroundImage,foregroundImageMediumId,foregroundImageFileName,removeBackgroundImage,backgroundImageMediumId,backgroundImageFileName,removeMenuImage,menuImageMediumId,menuImageFileName,namePropagation,longNamePropagation,descriptionPropagation,alternativeText1Propagation,alternativeText2Propagation,mediumPropagation,mediumFileName,removeMedium,backgroundColor,foregroundColor,styleId,toursCount,publishedToursCount,deleted,keywords',
        ISiteObjectTranslationDto:
            '++id,siteObjectId,languageId,name,longName,description,alternativeText1,alternativeText2,mediumId,text,deleted',
        ISiteObjectTypeDto: '++id,defaultExtensions,name',
        ISiteSupportedLanguageDto: '++id,siteId,languageId',
        IStyleDto:
            '++id,parentId,isDefault,siteId,name,description,foregroundImageMediumId,backgroundImageMediumId,backgroundColor,menuImageMediumId,backgroundModeId,menuColor,primaryFontFamilyId,primaryFontStyleId,primaryFontSize,primaryFontSizeUnitId,primaryFontColor,primaryFontAlignmentId,secondaryFontFamilyId,secondaryFontStyleId,secondaryFontSize,secondaryFontSizeUnitId,secondaryFontColor,secondaryFontAlignmentId,tertiaryFontFamilyId,tertiaryFontStyleId,tertiaryFontSize,tertiaryFontSizeUnitId,tertiaryFontColor,tertiaryFontAlignmentId,foregroundImageFileName,removeForegroundImage,menuImageFileName,removeMenuImage,backgroundImageFileName,removeBackgroundImage,hasChildren',
        ITourMenuItemDto: '++id,menuItemId,tourId,menuOrder',
        ITourRelatedSiteObjectDto: '++id,tourId,elementOrder,siteObjectId',
        ITourDto:
            '++id,name,fontColor,fontSize,fontName,backgroundColor,foregroundColor,description,siteId,tourTypeId,tourSubTypeId,styleId,tourStatusId,stage1,stage2,stage3,stage4,createdById,modifiedById,version,minorVersion,publishedVersion,testVersion',
        ITourStatusDto: '++id,name',
        ITourSubTypeDto: '++id,name,tourTypeId',
        ITourSupportedLanguageDto: '++id,siteSupportedLanguageId,tourId',
        ITourTranslationDto: '++tourSupportedLanguageId,name,completed',
        ITourTypeDto: '++id,name',
    },
    upgrade: (transaction: Transaction) => Promise.resolve(),
    preInsertCleanup: (dataIn: DataMap) => {
        return dataIn;
    },
};

export default module;
